import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import styles from './CircleBar.module.scss';

const cx = classNames.bind(styles);

interface CircleBarProps {
  value: number;
  color: string;
  label?: string;
}

const CircleBar = ({ value, color, label }: CircleBarProps): React.ReactElement => {
  const styles = useMemo(
    () =>
      buildStyles({
        strokeLinecap: 'round',
        pathColor: color,
      }),
    [value]
  );

  return (
    <div className={cx('body')}>
      <CircularProgressbar value={value} styles={styles} />
      <div className={cx('text')}>{label ?? value}</div>
    </div>
  );
};

export default CircleBar;
